export interface Campaign {
  id: number;
  query_parameters: Record<string, string | null>;
  modifications: Record<string, Modification[]>;
}

export interface Modification {
  selector: string;
  action: ModificationAction;
  value?: string | null;
  attr_name?: string | null;
  order?: number;
  media_temp_token?: string;
}

export enum ModificationAction {
  SET_TEXT = 'set_text',
  HIDE = 'hide',
  REPLACE_IMAGE = 'replace_image',
}

export interface SDKConfig {
  siteKey: string;
  debug?: boolean;
  autoApply?: boolean;
  platformOrigin?: string;
  endpoints?: {
    verify?: string;
    listModifications?: string;
    saveModificationsBulk?: string;
    campaignData?: string;
    uploadImage?: string;
  };
  onLoad?: (sdk: CampaignSDK) => void;
}

export interface EditorConfig extends SDKConfig {
  sessionToken: string;
  returnUrl?: string;
}

export interface SelectorMatchInfo {
  ok: boolean;
  count: number;
}

export interface CampaignSDK {
  initialize(siteKey: string, config: SDKConfig): Promise<void>;
  applyModifications(): void;
  destroy(): void;
  getVersion(): string;
  isDebug(): boolean;
}

export interface CampaignEditor {
  init(config: EditorConfig): void;
  show(): void;
  hide(): void;
  destroy(): void;
}

export interface Logger {
  debug(...args: any[]): void;
  info(...args: any[]): void;
  warn(...args: any[]): void;
  error(...args: any[]): void;
}

export interface ModificationRegistry {
  register(action: ModificationAction, handler: ModificationHandler): void;
  apply(modification: Modification, element: Element): void;
}

export interface ModificationHandler {
  apply(element: Element, modification: Modification): void;
  validate?(modification: Modification): boolean;
  remove(element: Element): void;
}

export interface SelectorEngine {
  generate(element: Element): string;
  validate(selector: string): boolean;
  getMatchInfo(selector: string): SelectorMatchInfo;
}

export interface PageMatcher {
  matches(path: string, campaign: Campaign): boolean;
  getCurrentPath(): string;
  getUrlParams(): Record<string, string>;
}

export interface APIResponse<T = any> {
  ok: boolean;
  data?: T;
  reason?: string;
  meta?: any;
}

export interface VerifyResponse extends APIResponse {
  data?: {
    es: string;
    page_url: string;
  };
}

export interface ModificationsResponse extends APIResponse {
  data?: {
    modifications: Modification[];
  };
}
